/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { S as Sizes, V as Variants } from './constants-c94b83bd.js';
import { D as DHL_HEADLINE } from './constants-366d7065.js';

const DHL_STAGE_TILES_MAIN_HEADLINE_SIZE = {
    SM: Sizes.SM,
    MD: Sizes.MD,
};
const DHL_STAGE_TILES_PSEUDO_LINK_VARIANT = {
    WHITE: "white",
    PRIMARY: "primary",
};
const DHL_STAGE_TILES_STAGE_VARIANT = {
    TILES_FULL: Variants.tilesFull,
    TILES_HALF: Variants.tilesHalf,
};
const DHL_STAGE_TILES = {
    HEADLINE_COLOR: DHL_HEADLINE.COLOR,
    MAIN_HEADLINE_SIZE: DHL_STAGE_TILES_MAIN_HEADLINE_SIZE,
    MAIN_HEADLINE_TAG: DHL_HEADLINE.TAG,
    PSEUDO_LINK_VARIANT: DHL_STAGE_TILES_PSEUDO_LINK_VARIANT,
    UPPER_HEADLINE_TAG: DHL_HEADLINE.TAG,
    STAGE_VARIANT: DHL_STAGE_TILES_STAGE_VARIANT,
};

export { DHL_STAGE_TILES as D };

//# sourceMappingURL=constants-fc728849.js.map